import { render } from "./comments.vue?vue&type=template&id=b4e2e024"
import script from "./comments.vue?vue&type=script&lang=js"
export * from "./comments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__